import DebugService from './DebugService';

const DEFAULT_INPUT_MAXLENGTH = undefined;

/**
 * Service
 * @folder Services
 * @class
 */
class ConfigService {

  /**
   * Renvoie l'instance du service
   * @returns {Service} singleton instance
   */
  static getInstance() {
    if (!ConfigService._instance) {
      ConfigService._instance = new ConfigService();
    }
    return ConfigService._instance;
  }

  constructor() {
    this.DEBUG = DebugService.getInstance().enabled;
    this.initialized = false;   // flag true/false
    this.input_maxlength = undefined; // undefined => pas de limite, sinon integer
  }

  init(input_maxlength = DEFAULT_INPUT_MAXLENGTH) {
    if (this.DEBUG) console.log('ConfigService - init...',{input_maxlength});
    this.input_maxlength = parseInt(input_maxlength);
    this.initialized = true;
  }


}

ConfigService._instance = null;

export default ConfigService;
